module.exports = __webpack_public_path__ + "static/media/APP_LifeSaver_152x174_3.09ab39ec.png";